import { cn } from '../lib/utils.js';

/**
 * Small segmented control for 2–4 mutually exclusive views (e.g. „aktuell / alle“).
 * Rendered as a group of toggle buttons (`aria-pressed`), so it works with Tab + Enter/Space.
 * @param {{
 *   value: string,
 *   onValueChange: (value: string) => void,
 *   options: Array<{ value: string, label: import('react').ReactNode }>,
 *   label: string,
 *   size?: 'default'|'sm',
 *   className?: string,
 * }} props
 */
export function ToggleGroup({ value, onValueChange, options, label, size = 'sm', className }) {
  return (
    <div
      role="group"
      aria-label={label}
      data-slot="toggle-group"
      className={cn('inline-flex w-fit items-center gap-0.5 rounded-md border bg-muted p-0.5', className)}
    >
      {options.map((option) => {
        const active = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={active}
            onClick={() => !active && onValueChange(option.value)}
            className={cn(
              'inline-flex items-center rounded-[calc(var(--radius)-4px)] px-3 font-medium text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-ring',
              size === 'sm' ? 'h-[calc(var(--control-height-sm)-6px)] text-[13px]' : 'h-[calc(var(--control-height)-6px)] text-sm',
              active && 'bg-card text-foreground shadow-sm',
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
